import { atom } from "recoil";
import GameVersion from "../enums/GameVersion";

const gameVersionState = atom<GameVersion>({
  key: "gameVersionState",
  default: GameVersion.fancy,
});

export default gameVersionState;
